
import { mapState } from 'vuex'
import cms from '~/mixins/common/cms'
export default {
    name: 'NavBar',
    mixins: [cms],
    data: () => ({
        drawer: true,
        hostname: null,
        gameIndex: null,
    }),
    computed: {
        ...mapState({
            isLogin: (state) => state.settings.isLogin,
            player: (state) => state.player.player,
            menubars: (state) => state.cms.menus.menus,
            onHoldWallet: (state) => state.player.onHoldWallet,
        }),
    },
    watch: {
        '$route.query.idx'(value) {
            this.gameIndex = value
        },
    },
    mounted() {
        if (this.$cookie.get('token')) {
            if (this.player?.player_id) return
            this.$store.dispatch('player/profile')
            this.$store.dispatch('settings/toggleIsLogin', true)
            this.$store.dispatch('player/totalBalance')
        }
    },
}
